/**
* Build default store state from store models
* Note: Should not go to localStorage
*/
import { userModelData } from './modules/ManageUsers/models/AdminUserModel'
import { countryModelData } from './modules/ManageCountries/models/CountriesModel'
import { countyModelData } from './modules/ManageCounties/models/CountiesModel'
import { stateModelData } from './modules/ManageStates/models/AdminStateModel'
import { authModelData } from './modules/Authentication/models/AuthModel'
import { jurisdictionModelData } from './modules/ManageJurisdictions/models/JurisdictionsModel'
import { publisherModelData } from './modules/ManagePublishers/models/PublishersModel'
import { CodeYearModelData } from './modules/ManageCodeYears/models/CodeYearsModel'
import { adoptionProfileModelData } from './modules/ManageAdoptionProfiles/models/AdoptionProfilesModel'
import { adoptionStatusModelData } from './modules/ManageAdoptionStatuses/models/AdoptionStatusesModel'
import { adoptionTypeModelData } from './modules/ManageAdoptionTypes/models/AdoptionTypesModel'
import { CodeBookModelData } from './modules/ManageCodeBooks/models/CodeBooksModel'
import { adoptionLabelModelData } from './modules/ManageAdoptionLabels/models/AdoptionLabelsModel'
import { AdoptionModelData } from './modules/ManageAdoptions/models/AdoptionModel'
import { PostalCodeModelData } from './modules/ManagePostalCodes/models/PostalCodesModel'
import { AuditLogModelData } from './modules/ManageAuditLogs/models/AuditLogModel'
import { SearchModelData } from './frontendModules/Search/models/SearchModel'
import { MapModelData } from './frontendModules/Map/models/MapModel'
import { AdminVersionModelData } from './modules/ManageVersion/models/AdminVersionModel'
import { LocationEntityImportModelData } from './modules/ManageLocationEntityImport/models/LocationEntityImportModel'
import { townshipModelData } from './modules/ManageTownships/models/TownshipsModel'
import { SampleDownloadModelData } from './modules/ManageSampleDownload/models/SampleDownloadModel'
import { ICodeColorModelData } from './modules/ManageICodeColors/models/ICodeColorModel'
import { CountryDetailsData } from './frontendModules/CountryDetails/models/CountryDetailsModel'

export default function getDefaultState () {
  return {
    // Reset states in the main store
    drawer: false,
    DashBoard_Message: 'Welcome to Dashboard Page!',

    // Reset states in the modules
    AuthModule: authModelData(),
    StateModule: stateModelData(),
    CountyModule: countyModelData(),
    CountryModule: countryModelData(),
    UserModule: userModelData(),
    JurisdictionModule: jurisdictionModelData(),
    PublisherModule: publisherModelData(),
    CodeYearModule: CodeYearModelData(),
    AdoptionProfileModule: adoptionProfileModelData(),
    AdoptionStatusModule: adoptionStatusModelData(),
    AdoptionTypeModule: adoptionTypeModelData(),
    CodeBookModule: CodeBookModelData(),
    AdoptionLabelModule: adoptionLabelModelData(),
    AdoptionModule: AdoptionModelData(),
    PostalCodesModule: PostalCodeModelData(),
    AuditLogModule: AuditLogModelData(),
    SearchModule: SearchModelData(),
    MapModule: MapModelData(),
    AdminVersionModule: AdminVersionModelData(),
    LocationEntityImportModule: LocationEntityImportModelData(),
    TownshipModule: townshipModelData(),
    SampleDownloadModule: SampleDownloadModelData(),
    ICodeColorModelData: ICodeColorModelData(),
    CountrryDetatilsModule: CountryDetailsData()
  }
}
